import React from "react";
import Auth from "@rill/auth";

function View(props, { locals }) {
  const { query } = locals;
  const { redirect } = query;
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Strength Book"
      />

      <form method="POST" data-noreset>
        {redirect && <input type="hidden" name="redirect" value={redirect} />}

        <div className="frame narrow">
          <div className="columns">
            <div className="column" data-col="1/1">
              <label htmlFor="email" className="label">
                E-mail <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                type="email"
                name="email"
                placeholder="Email"
                required
              />
            </div>

            <div className="column" data-col="1/1">
              <label htmlFor="password" className="label">
                Password <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                type="password"
                name="password"
                placeholder="Password"
                required
              />
            </div>

            <div className="column" data-col="1/2">
              <label className="checkbox-input">
                <input type="checkbox" name="remember" />
                <span className="checkbox" />
                <span className="text">Remember Me</span>
              </label>
            </div>

            <div
              className="column"
              data-col="1/2"
              style={{ textAlign: "right" }}
            >
              <a href="/forgot">Forgot Password?</a>
            </div>

            <div className="column" data-col="1/1">
              <button className="button-input full" type="submit">
                Log In
              </button>
            </div>
          </div>
        </div>
        <div className="login-signup">
          Are you a coach? <a href="/signup-coach"> Sign up here</a>
        </div>
        <div className="login-signup">
          <a href="/login-new-onboarding">New onboarding</a>
        </div>
      </form>
    </div>
  );
}

const Login = (app) => {
  app
    .get(
      "/login-old",
      Auth.isLoggedOut({ redirect: "dashboard" }),
      ({ res }) => (res.body = <View />)
    )
    .post("/login", async ({ req: { body }, res, api, login, flash }) => {
      const { redirect = "/coaching-portal" } = body;
      delete body.redirect;
      const { token, userId, error } = await (
        await api("login", {
          method: "POST",
          body,
        })
      ).json();

      if (error) {
        const errorMessage = error.message || "An error occurred";
        flash("error", errorMessage);
        return res.backDontScroll();
      }

      let sessionOptions = { refresh: true };
      if (!body.remember) {
        sessionOptions.ttl = "2 weeks";
      }
      await login({ _id: userId, token }, sessionOptions);

      if (process.browser && window && window.FullStory) {
        window.FullStory.identify(userId, {
          email: body.email,
        });
      }

      if (redirect === "back") res.backDontScroll();
      else res.redirect(redirect);
    })
    .get("/logout", ({ req, res, logout, session }) => {
      if (typeof window !== "undefined" && window.localStorage) {
        localStorage.removeItem("exercisesToCopy");
        localStorage.removeItem("originalAthleteLibraryToCopy");
      }
      logout();
      session.clear();
      res.redirect("/login" + req.search);
    });
};

export default Login;
